module.exports = __webpack_public_path__ + "media/components/HowItWorks/components/Reviews/chevron-001199f73efcdac8d4b2d7565bc374a5.png";